/**
 * Function to create an HTML element with specified parameters.
 * @param {Object} options - Object containing parameters for creating the element.
 * @param {string} options.tag - HTML element tag (default is 'div').
 * @param {string} options.text - Text content of the element (default is an empty string).
 * @param {[Element | string]} options.children - Zero or more child elements to add to the element. Strings are converted to text nodes.
 * @param {HTMLElement} options.parent - Parent HTML element to which the created element is appended (default is null).
 * @param {Array} options.classes - Array of classes to be added to the created element (default is an empty array).
 * @param {string} options.id - ID to be added to the created element (default is undefined).
 * @param {string|number} options.value - Value to be added to the created element.
 * @param {string} options.style
 * @returns {HTMLElement} - Created HTML element.
 */
export function createElement(options) {
  const {
    tag = "div",
    text = "",
    children,
    parent,
    classes = [],
    id,
    value,
    style,
  } = options;

  const element = document.createElement(tag);
  element.textContent = text;

  if (children) {
    children.forEach((child) => {
      if (typeof child === "string") {
        element.append(document.createTextNode(child));
      } else {
        element.append(child);
      }
    });
  }

  if (parent) {
    parent.append(element);
  }

  if (classes.length > 0) {
    element.classList.add(...classes);
  }

  if (id) {
    element.id = id;
  }

  if (value && "value" in element) {
    element.value = String(value);
  }

  if (style) {
    element.style = style;
  }

  return element;
}
